import { ProductFeature, ProductFeatureStatus } from "components/product/product.types";
import { PlanProps } from "shared/components/plan/plan";
import { LIBUM_DOCS_POWERON_PRO, LIBUM_PORTAL, POWERON_PRO_INSTALL_URL } from "shared/constants/globals";
import { PlanOfferings } from "shared/constants/plans";
import { createItems } from "shared/constants/utilities";

export const POWERON_PRO_FEATURES: ProductFeature[] = [{
  id: 'remote-syms',
  name: 'Remote Syms',
  description: 'Get a semi-virtual workspace for the LetterSpecs, HelpFiles, DataFiles, and PowerOn directories on any Sym with SFTP or rsync synchronization',
  isFeatured: true,
  isHidden: false,
  offeringType: "Plus",
  imagePath: '/images/578ddfe2-7299-4b1a-8917-454f4a031234.gif',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#remote-syms`,
}, {
  id: 'symitar-integration-https',
  name: 'Symitar Integration (HTTPS)',
  description: 'Connect directly to Symitar and take advantage of realtime PowerOn validation, deployments, and batch execution',
  isFeatured: true,
  isHidden: false,
  offeringType: "Plus",
  imagePath: '/images/07b1ff8c-8e4a-4ab5-954b-a00e875f580a.gif',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#direct-integration-to-symitar-https`,
}, {
  id: 'ondemand-rendering',
  name: 'On-Demand Rendering',
  description: 'Choose an account and run on-demand PowerOns straight from VS Code',
  isFeatured: false,
  isHidden: false,
  offeringType: "Plus",
  imagePath: '',
  status: ProductFeatureStatus.IN_DEVELOPMENT,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#on-demand-poweron-rendering`,
}, {
  id: 'edocs-hovers',
  name: 'eDocs Hovers',
  description: 'Gain insight from eDocs into the keyword, function, template, or database record',
  isFeatured: false,
  isHidden: false,
  imagePath: '',
  offeringType: "Free",
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#hovers`,
}, {
  id: 'poweron-diagnostics',
  name: 'PowerOn Diagnostics',
  description: 'Evolving realtime diagnostics (undefined / unused variables, incorrect syntax, etc.) of your PowerOns',
  isFeatured: false,
  isHidden: false,
  offeringType: "Plus",
  imagePath: '',
  status: ProductFeatureStatus.CONTINUOUS_DEVELOPMENT,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#poweron-diagnostics`,
}, {
  id: 'syntax-highlighting',
  name: 'Syntax Highlighting',
  description: 'The most complete and robust highlighting for the PowerOn language',
  isFeatured: false,
  isHidden: true,
  offeringType: "Free",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#syntax-highlighting`,
}, {
  id: 'file-icon-theme',
  name: 'File Icon Theme',
  description: 'An extended Seti (built-in) icon theme with known PowerOn file extensions',
  isFeatured: false,
  isHidden: true,
  offeringType: "Free",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#file-icon-theme`,
}, {
  id: 'code-completions',
  name: 'Code Completions',
  description: 'Get prompted as you type with relevant and helpful completions',
  isFeatured: false,
  isHidden: true,
  offeringType: "Free",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#code-completions`,
}, {
  id: 'definitions-and-references',
  name: 'Definitions & References',
  description: 'Quickly navigate the definitions, references, and dependencies of your PowerOn',
  isFeatured: false,
  isHidden: true,
  offeringType: "Free",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#multi-document-definitions-and-references`,
}, {
  id: 'code-snippets',
  name: 'Code Snippets',
  description: 'Get started faster with an extensible snippet library',
  isFeatured: false,
  isHidden: true,
  offeringType: "Free",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#code-snippets`,
}, {
  id: 'function-signatures',
  name: 'Function Signatures',
  description: 'Know what the PowerOn function does as you write it',
  isFeatured: false,
  isHidden: true,
  offeringType: "Free",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#function-signatures`,
}, {
  id: 'poweron-tasks',
  name: 'PowerOn Tasks',
  description: `Keep track of what's next for your PowerOn "todos"`,
  isFeatured: false,
  isHidden: true,
  offeringType: "Free",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#tasks`,
}, {
  id: 'poweron-code-formatter',
  name: 'PowerOn Code Formatter',
  description: `Ensure all of your PowerOns conform to a consistent style with configurable indentation, keyword casing, and spacing options`,
  isFeatured: false,
  isHidden: true,
  offeringType: "Plus",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#poweron-code-formatter`,
}, {
  id: 'symitar-integration-ssh',
  name: 'Symitar Integration (SSH)',
  description: 'Connect directly to Symitar and take advantage of realtime PowerOn validation, deployments, and batch execution (Legacy)',
  isFeatured: false,
  isHidden: true,
  offeringType: "Free",
  imagePath: '/images/07b1ff8c-8e4a-4ab5-954b-a00e875f580a.gif',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#direct-integration-to-symitar-ssh`,
}, {
  id: 'source-control-management',
  name: 'Remote Syms SCM',
  description: `Don't worry about clobbering files as you sync, we'll funnel these through the source control manager`,
  isFeatured: false,
  isHidden: true,
  offeringType: "Plus",
  imagePath: '/images/07b1ff8c-8e4a-4ab5-954b-a00e875f580a.gif',
  status: ProductFeatureStatus.PLANNED,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#remote-syms-scm`,
}, {
  id: 'embedded-html-support',
  name: 'HTML Language Support',
  description: `Get the HTML syntax highlighting within your PowerOns but also forget about wrapping every line in htmlViewLine`,
  isFeatured: false,
  isHidden: true,
  offeringType: "Plus",
  imagePath: '/images/07b1ff8c-8e4a-4ab5-954b-a00e875f580a.gif',
  status: ProductFeatureStatus.PLANNED,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#embedded-html-language-support`,
}, {
  id: 'symx-poweron-development',
  name: 'SymX PowerOn Development',
  description: `Manage the full lifecycle of SymX PowerOns without opening Symitar Quest`,
  isFeatured: false,
  isHidden: true,
  offeringType: "Plus",
  imagePath: '/images/07b1ff8c-8e4a-4ab5-954b-a00e875f580a.gif',
  status: ProductFeatureStatus.PLANNED,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#symxchange-poweron-development`,
}, {
  id: 'job-files-manager',
  name: 'Job Files Manager',
  description: `Skip out on the wizard prompts and use templates to prototype new batch jobs in seconds`,
  isFeatured: false,
  isHidden: true,
  offeringType: "Plus",
  imagePath: '',
  status: ProductFeatureStatus.PLANNED,
}, {
  id: 'clone-sym-directory',
  name: 'Clone Sym Directory',
  description: `Clone entire directories between Syms to quickly replicate PowerOns, DataFiles, and other assets`,
  isFeatured: false,
  isHidden: true,
  offeringType: "Free",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#clone-sym-directory`,
}, {
  id: 'compare-with-sym',
  name: 'Compare with Another Sym',
  description: `Compare files across different Syms to identify differences and ensure consistency`,
  isFeatured: false,
  isHidden: true,
  offeringType: "Free",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#compare-with-another-sym`,
}, {
  id: 'auto-deploy-includes',
  name: 'Auto-Deploy Include Files',
  description: `Intelligently manage #INCLUDE file deployments with options to prompt, silently deploy, or skip`,
  isFeatured: false,
  isHidden: true,
  offeringType: "Free",
  imagePath: '',
  status: ProductFeatureStatus.AVAILABLE,
  docsLink: `${LIBUM_DOCS_POWERON_PRO}/capabilities#auto-deploy-include-files`,
}]

export const POWERON_PRO_PLAN_FEATURES = [{
  name: 'Complete language server for PowerOn',
  offerings: [{
    name: PlanOfferings.POWERON_PRO,
  }, {
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}, {
  name: 'File icon themes',
  offerings: [{
    name: PlanOfferings.POWERON_PRO,
  }, {
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}, {
  name: 'Direct links to eDocs on keyword hover',
  offerings: [{
    name: PlanOfferings.POWERON_PRO,
  }, {
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}, {
  name: `Create and track your "To-Dos" inline PowerOn`,
  offerings: [{
    name: PlanOfferings.POWERON_PRO,
  }, {
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}, {
  name: 'PowerOn code formatter',
  offerings: [{
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}, {
  name: 'Real-time PowerOn diagnostics',
  offerings: [{
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}, {
  name: 'Direct integration to Symitar<br>Validate, Deploy, Install, and Execute',
  offerings: [{
    name: PlanOfferings.POWERON_PRO,
    description: 'SSH (Legacy)'
  }, {
    name: PlanOfferings.POWERON_PRO_PLUS,
    description: 'SSH + HTTPs'
  }]
}, {
  name: 'Semi-virtual workspaces for remote syms<br>SFTP or rsync synchronization',
  offerings: [{
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}, {
  name: 'Clone directories between Syms',
  offerings: [{
    name: PlanOfferings.POWERON_PRO,
  }, {
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}, {
  name: 'Compare files across Syms',
  offerings: [{
    name: PlanOfferings.POWERON_PRO,
  }, {
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}, {
  name: 'Source control management for remote syms',
  offerings: [{
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}, {
  name: 'Revamped UI for batch and print control',
  offerings: [{
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}, {
  name: 'Embedded HTML language support',
  offerings: [{
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}, {
  name: 'On-Demand PowerOn rendering',
  offerings: [{
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}, {
  name: 'SymXchange development',
  offerings: [{
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}, {
  name: 'Job files manager',
  offerings: [{
    name: PlanOfferings.POWERON_PRO_PLUS
  }]
}];
export const POWERON_PRO_PLAN_FEATURES_MAP = createItems(POWERON_PRO_PLAN_FEATURES, 'poweron-pro');

export const POWERON_PRO_PLAN: PlanProps = {
  header: 'Use PowerOn Pro for free, or subscribe to next-level features',
  features: POWERON_PRO_PLAN_FEATURES_MAP,
  offerings: [{
    name: PlanOfferings.POWERON_PRO,
    id: 'offering-poweron-pro',
    class: 'poweron-pro',
    link: {
      href: POWERON_PRO_INSTALL_URL,
      text: 'Install Now',
    }
  }, {
    name: PlanOfferings.POWERON_PRO_PLUS,
    id: 'offering-poweron-pro-plus',
    class: 'poweron-pro',
    link: {
      href: LIBUM_PORTAL,
      text: 'Subscribe',
    }
  }]
}
